import { useContext } from 'react';
import { Connector as BaseConnector } from '@visx/annotation';
import DataContext from "../../context/DataContext.js";
import { jsx as _jsx } from "react/jsx-runtime";
/** AnnotationConnector which provides color from theme. */
export default function AnnotationConnector(props) {
  const {
    theme
  } = useContext(DataContext);
  return /*#__PURE__*/_jsx(BaseConnector, {
    stroke: theme?.axisStyles.x.bottom.axisLine.stroke,
    ...props
  });
}